import {Injectable} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {
  EditAccessoryDialogComponent,
  EditAccessoryDialogModel,
  EditAccessoryDialogResultModel,
} from "./edit-accessory-dialog.component";
import {Apollo} from "apollo-angular";
import {
  StandaloneAccessoryDeleteGqlModel,
  StandaloneAccessoryGqlModel,
  StandaloneAccessoryInputGqlModel,
  StandaloneAccessoryInputResponseGqlModel,
  StandaloneAccessoryInputListGqlModel,
} from "./standalone-accessory.gql-model";
import {
  AssociateStandaloneAccessoryDialogComponent,
} from "../workflow/deployment/associate-standalone-accessory-dialog.component";

@Injectable()
export class AccessoryService {
  constructor(
    private apollo: Apollo,
    private dialogService: DialogService,
  ) {}

  getAccessory(accessoryId: string, siteId?: string, assetId?: string): Promise<StandaloneAccessoryGqlModel> {
    const query = StandaloneAccessoryGqlModel.query;
    const variables = StandaloneAccessoryGqlModel.variables(accessoryId, siteId, assetId);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(StandaloneAccessoryGqlModel.mapper)
      .toPromise();
  }

  saveAccessory(accessory: StandaloneAccessoryGqlModel): Promise<StandaloneAccessoryInputResponseGqlModel> {
    const model = new StandaloneAccessoryInputGqlModel({accessory, accessoryId: accessory.id});
    return this.apollo.mutate({mutation: model.mutation, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(StandaloneAccessoryInputGqlModel.mapper)
      .toPromise();
  }

  saveAccessories(accessories: StandaloneAccessoryGqlModel[]): Promise<StandaloneAccessoryInputResponseGqlModel[]> {
    const model = new StandaloneAccessoryInputListGqlModel({accessories});

    return this.apollo.mutate({mutation: model.mutation, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(StandaloneAccessoryInputListGqlModel.mapper)
      .toPromise();
  }

  deleteAccessory(id: string): Promise<StandaloneAccessoryInputResponseGqlModel> {
    const model = new StandaloneAccessoryDeleteGqlModel({accessoryId: id});

    return this.apollo.mutate({mutation: model.mutation, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(StandaloneAccessoryDeleteGqlModel.mapper)
      .toPromise();
  }

  createAccessory(siteId: string, assetId?: string): Promise<EditAccessoryDialogResultModel> {
    return this.dialogService.showDialog(EditAccessoryDialogComponent, {siteId, assetId} as EditAccessoryDialogModel);
  }

  editAccessory(obj: string | StandaloneAccessoryGqlModel): Promise<EditAccessoryDialogResultModel> {
    const model = {} as EditAccessoryDialogModel;

    if (typeof obj === "string") model.accessoryId = obj;
    if (obj instanceof StandaloneAccessoryGqlModel) model.accessory = obj;

    return this.dialogService.showDialog(EditAccessoryDialogComponent, model);
  }

  associateStandaloneAccessory(deploymentId: string, accessoryId: string): Promise<boolean> {
    return this.dialogService.showDialog(AssociateStandaloneAccessoryDialogComponent, {deploymentId, accessoryId});
  }
}
